var map = {
	"./cs.json": 9109,
	"./de.json": 1272,
	"./en.json": 5188,
	"./fr.json": 2303,
	"./kk.json": 2837,
	"./pl.json": 9815,
	"./ru.json": 7526,
	"./zh.json": 7157
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9628;